exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.no-data[data-v-7a64258a] {\n  text-align: center;\n  padding-bottom: 40px;\n  width: 100%;\n}\n.no-data .title[data-v-7a64258a] {\n    margin-top: 20px;\n    font-size: 16px;\n    color: #999;\n}\n", "", {"version":3,"sources":["F:/forex/web/forex-websrc/src/components/common/noData/noData.vue"],"names":[],"mappings":";AAAA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;CAAE;AACd;IACE,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;CAAE","file":"noData.vue","sourcesContent":[".no-data {\n  text-align: center;\n  padding-bottom: 40px;\n  width: 100%; }\n  .no-data .title {\n    margin-top: 20px;\n    font-size: 16px;\n    color: #999; }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-7a64258a","scoped":true,"sourceMap":true}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/noData/noData.vue
// module id = 571
// module chunks = 1